module.exports = __webpack_public_path__ + "img/recommed-img4.a4fea3de.jpg";